module.exports = __webpack_public_path__ + "img/1.26ef6a73.png";